var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate3 = function SvgTemplate3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20 4H4C3.44772 4 3 4.44772 3 5V9C3 9.55228 3.44772 10 4 10H20C20.5523 10 21 9.55228 21 9V5C21 4.44772 20.5523 4 20 4Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10 12H4C3.44772 12 3 12.4477 3 13V19C3 19.5523 3.44772 20 4 20H10C10.5523 20 11 19.5523 11 19V13C11 12.4477 10.5523 12 10 12Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20 12H14C13.4477 12 13 12.4477 13 13V19C13 19.5523 13.4477 20 14 20H20C20.5523 20 21 19.5523 21 19V13C21 12.4477 20.5523 12 20 12Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate3;